import {
  SET_THEME
} from "./commonActionTypes";

export const setTheme = (theme: string) => {
  return {
    type: SET_THEME,
    payload: theme,
  };
};
